import { request } from "@/api/request";
import util from "@/mixins/util";

const state = {
  oneDepth: []
};

const getters = {
  getOneDepth: state => state.oneDepth
};

const mutations = {
  setOneDepth(state, data) {
    state.oneDepth = data;
  },
  updateChild(state, { parentIdx, childIndex, grandchildIndex, greatGrandchildIndex, result }) {
    if (grandchildIndex !== null) {
      if (greatGrandchildIndex !== null) {
        if (state.oneDepth[parentIdx].Child[childIndex].Child[grandchildIndex]) {
          state.oneDepth[parentIdx].Child[childIndex].Child[grandchildIndex].Child = result;
        }
      } else {
        state.oneDepth[parentIdx].Child[childIndex].Child[grandchildIndex].Child = result;
      }
    } else {
      state.oneDepth[parentIdx].Child[childIndex].Child = result;
    }
  }
};

const actions = {
  setOneDepth({ commit }) {
    let params = {
    };

    return request.javaGet("v1/admin/authorities/cms", params).then(res => {
            let result = res.data.result.list;
            commit("setOneDepth", result);
        });
  },
  updateChild({ commit }, payload) {
    commit("updateChild", payload);
  }
};

export default { namespaced: true, state, getters, mutations, actions };
